exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1TGldRaVFwhZq1{background-color:#fafbfc}._13LDD8KFLGD_qv{position:-webkit-sticky;position:sticky;top:0}.Eyf--wZG1WBKtC{width:764px}._3pSMVM2UPBAbCn{display:flex;flex-direction:column;box-sizing:border-box;padding:24px}._2mT0CLNE56h4Xc{margin:20px 0}", ""]);

// exports
exports.locals = {
	"teamReportsPage": "_1TGldRaVFwhZq1",
	"leftNav": "_13LDD8KFLGD_qv",
	"contentContainer": "Eyf--wZG1WBKtC",
	"orientationCard": "_3pSMVM2UPBAbCn",
	"loading": "_2mT0CLNE56h4Xc"
};